import { getError } from 'helpers/errors';
import React, { Component } from 'react';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

class ProcessingFeeExemptToggle extends Component {
  state = {
    isOpenModal: false,
  };

  openModal = () => {
    this.setState({ isOpenModal: true, error: '' });
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  toggle = async (event) => {
    const { userId, status, onToggle, onToggleComplete } = this.props;
    try {
      await onToggle(userId, !status);
      onToggleComplete(userId);
      this.setState({
        error: '',
      });
    } catch (err) {
      const error = getError(err);
      this.setState({ error });
    }
  };

  render() {
    const { status } = this.props;
    const { error, isOpenModal } = this.state;
    const message = status
      ? 'Disable processing fee exempt'
      : 'Enable processing fee exempt';

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.openModal}>
          {message}
        </button>
        {error && (
          <React.Fragment>
            <br />
            <span className="text-danger">{error}</span>
          </React.Fragment>
        )}
        <ConfirmModal
          isOpen={isOpenModal}
          title="Confirm Processing Fee Exempt Toggle"
          description={`Are you sure you want to ${message.toLowerCase()}?`}
          onClose={this.closeModal}
          onConfirm={this.toggle}
        />
      </React.Fragment>
    );
  }
}

export default ProcessingFeeExemptToggle;
